import React, { useContext, useEffect, useState } from "react";
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import {
  LOGIN_ROUTE,
  MAIN_ROUTE,
  REPORTS_ROUTE,
  REPORT_ROUTE,
  CONTRACTS_ROUTE,
  UPLOAD_ROUTE,
  USERS_ROUTE,
    FILE_ROUTE,
    TRACKS_ROUTE
} from "../utils/constants";
import Auth from "../pages/Auth";
import Main from "../pages/Main";
import { Context } from "../index";
import { observer } from "mobx-react-lite";
import NavBar from "./NavBar";
import Upload from "../pages/Upload";
import Users from "../pages/Users";
import Singers from "../pages/Singers";
import Report from "../pages/Report";
import Contracts from "../pages/Contracts";
import Reports from "../pages/Reports";
import UploadForm from "../pages/UploadForm";
import File from "../pages/File";
import Tracks from "../pages/Tracks";

const AppRouter = observer(() => {
  const { user } = useContext(Context);

  const [auth, setAuth] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      if (token) setAuth(true);
      else setAuth(false);
    };
    checkAuth();
  }, []);

  return (
    <BrowserRouter>
      {auth === true && <NavBar />}
      <Routes>
        {auth === true && (
          <>
            <Route exact path={MAIN_ROUTE} element={<Main />} />
            <Route exact path={TRACKS_ROUTE} element={<Tracks />} />
            <Route path={FILE_ROUTE + "/:file"} element={<File />} />
            <Route exact path={UPLOAD_ROUTE} element={<Upload />} />
            <Route exact path={UPLOAD_ROUTE + "/form"} element={<UploadForm />} />
            {/*<Route exact path={CONTRACTS_ROUTE} element={<Singers />} />*/}
            <Route exact path={USERS_ROUTE} element={<Users />} />
            <Route path={REPORT_ROUTE + "/:report"} element={<Report />} />
            <Route path={REPORTS_ROUTE + "/:contract"} element={<Reports />} />
            <Route exact path={CONTRACTS_ROUTE} element={<Contracts />} />
          </>
        )}
        <Route exact path={LOGIN_ROUTE} element={<Auth />} />
        {/* <Route exact path={REGISTRATION_ROUTE} element={<Auth />} /> */}
        {/* <Route path="*" element={<Navigate to={LOGIN_ROUTE} replace />} /> */}
      </Routes>
    </BrowserRouter>
  );
});

export default AppRouter;
